import { z } from "zod";

export const queryGroupPatternTypeEnum = z.enum([
  "INCLUDES",
  "STARTS_WITH",
  "ENDS_WITH",
  "EQUALS",
  "REGEX",
  "NOT_INCLUDES",
  "CONTAINS",
  "NOT_CONTAINS",
  "NOT_REGEX",
]);

export type QueryGroupPatternType = z.infer<typeof queryGroupPatternTypeEnum>;
